
import { Options, Vue } from "vue-class-component";
import Menu from "@/components/Menu.vue";
import Content from "@/components/Content.vue";
import * as d3 from "d3";
import * as _ from "lodash";

@Options({
  components: {
    Menu,
    Content,
  },
  computed: {
    mobile() {
      return this.$store.state.mobile;
    },
    landingData: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      get() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return this.$store.state.landingData;
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      set(value) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.$store.state.landingData = value;
      },
    },
    groupedLandingData: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      get() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return this.$store.state.groupedLandingData;
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      set(value) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.$store.state.groupedLandingData = value;
      },
    },
    sectionTabs: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      get() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return this.$store.state.sectionTabs;
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      set(value) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.$store.state.sectionTabs = value;
      },
    },
    titleTabs: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      get() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return this.$store.state.titleTabs;
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      set(value) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.$store.state.titleTabs = value;
      },
    },
    selectedSectionTab: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      get() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return this.$store.state.selectedSectionTab;
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      set(value) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.$store.state.selectedSectionTab = value;
      },
    },
    selectedTitleTab: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      get() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return this.$store.state.selectedTitleTab;
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      set(value) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.$store.state.selectedTitleTab = value;
      },
    },
    selectedContent: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      get() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return this.$store.state.selectedContent;
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      set(value) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.$store.state.selectedContent = value;
      },
    },
  },
  async mounted() {
    console.log(this.$store.state.mobile, "MOBILE");
    this.landingData = await this.$store.dispatch("getLanding");
    //console.log(this.landingData);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.groupedLandingData = d3.group(
      this.landingData,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      d => d["Sección"],
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      d => d["Título"],
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      d => d.Contenido
    );
    this.sectionTabs = Array.from(this.groupedLandingData.keys());
    this.selectedSectionTab = this.sectionTabs[0];
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.titleTabs = Array.from(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.groupedLandingData.get(this.selectedSectionTab).keys()
    );
    this.selectedTitleTab = this.titleTabs[0];

    if (!this.$store.state.mobile) {
      // Get the navbar
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      let navbar = document.getElementById("Content");

      // Get the offset position of the navbar
      let sticky = navbar ? navbar.clientHeight : 500;

      window.onscroll = () => {
        if (window.pageYOffset >= sticky) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          document.getElementById("Menu").classList.add("sticky");
        } else {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          document.getElementById("Menu").classList.remove("sticky");
        }
      };
    }
  },
})
export default class Home extends Vue {}
